<template>
  <div>
    <div style="background-color: #fff; padding-bottom: 30px;">
      <!-- <mdb-container>
        <mdb-row>
          <div class="progress__container">
            <img src="/img/progress/W02.svg" style="width: 100%; height: auto;" alt />
          </div>
        </mdb-row>
      </mdb-container> -->
    </div>
    <div style="background-color: #f7f7f7;" class="mt-1 pt-1 cardClass">
      <mdb-container
        style="max-width: 97% !important; padding-bottom: 0rem; background-color: #fff; -webkit-box-shadow: 0px 6px 15px 0px rgba(0,0,0,0.34); -moz-box-shadow: 0px 6px 15px 0px rgba(0,0,0,0.34); box-shadow: 0px 6px 15px 0px rgba(0,0,0,0.34);"
        class="mt-5"
      >
      <div class="text-justify" style="padding: 5rem; font-family: 'Open Sans'; font-size:14px;" >
          <mdb-row class="pr-5" style="display: flex; float: right;">
          
          <mdb-col md="1" class="text-right" style="margin-left: 24%;">
            <p
              style="font-size: 30px; cursor: pointer; color: #000; font-weight: 700;"
              @click="$router.push('/home')"
            >x</p>
          </mdb-col>
        </mdb-row>
          <span style="font-family: 'Josefin Sans'; font-size:20px; color: #dc7134; font-weight: 600;">Preguntas frecuentes - Sistema de Solicitudes de Admisión</span>
          <p style="font-weight: 700;">1.- ¿Mi código de confirmación expira?</p>
          <p>
              <ul>Sí, el código cuenta con un periodo de tiempo válido de 10 minutos.
              </ul>
          </p>
          <p style="font-weight: 700;">2.- ¿Qué pasa si el código de confirmación expira?</p>
          <p>
              <ul>Al intentar registrar ese código se muestra un mensaje donde se te informa que se te ha enviado uno nuevo a tu correo. Revisa tu bandeja de entrada.
              </ul>
          </p>
           <p style="font-weight: 700;">3.- ¿El tiempo para crear mi contraseña expira?</p>
          <p>
              <ul>Sí, el tiempo de creación al igual que la confirmación de código expira, con la diferencia de que aquí son 5 minutos.
              </ul>
          </p>
          <p style="font-weight: 700;">4.- ¿Qué pasa si el tiempo para crear mi contraseña expira?</p>
          <p>
              <ul>Al momento de intentar crear tu contraseña se te informa que el tiempo ha expirado y que se te ha enviado un nuevo código para confirmarlo de nuevo y proceder a crear la contraseña. Revisa tu bandeja de entrada.</ul>
          </p>
          
          <p style="font-weight: 700;">5.- No me llega el correo con la confirmación de correo, ¿Qué hago?</p>
          <p>
              <ul>Revisa en Spam o No deseados en tu cuenta de correo con la que realizaste tu registro.</ul>
          </p>
          
          <p style="font-weight: 700;">6.- No puedo tomar la foto de mi rostro, ¿Qué hago?</p>
          <p>
              <ul>Asegurate de haber concedido el permiso al sistema de usar tu cámara. 
                  <ul>Para ello realiza los siguientes pasos:
                      <li>Sobre la barra de búsqueda de tu navegador, aún estando en el sistema, ubica un icono de cámara.</li>
<li>Da clic sobre ese icono, se te mostrará una pequeña ventana.</li>
<li>Elige la opción donde menciona algo similar a: 
Seguir permitiendo que: https://solicitudes.kiritek.com/ acceda a la cámara.</li>
<li>Da clic en el botón “Listo” o “Guardar”.</li>
<li>Listo puedes hacer uso de la cámara de tu computadora.</li>
                  </ul>


              </ul>
          </p>
          
          <p style="font-weight: 700;">7.- No puedo adjuntar mis documentos, ¿Cómo los subo?</p>
          <p>
              <ul>
                  <li>Asegurate de que los documentos requeridos se encuentren en un formato PDF.</li> 
<li>Haz clic sobre el icono de subir de uno de los documentos.</li>
<li>Selecciona tu documento en PDF. Asegurate que sea el correcto.</li>
<li>El documento se carga correctamente cuando el icono de subir el documento cambie a verde.</li>

                  
              </ul>
          </p>
          
          <p style="font-weight: 700;">8.- No puedo adjuntar los documentos de mi Cónyuge, ¿Cómo los subo?</p>
          <p>
               <ul>
                  <li>Asegurate de que los documentos requeridos se encuentren en un formato PDF.</li> 
<li>Haz clic sobre el icono de subir de uno de los documentos.</li>
<li>Selecciona tu documento en PDF. Asegurate que sea el correcto.</li>
<li>El documento se carga correctamente cuando el icono de subir el documento cambie a verde.</li>

                  
              </ul>
          </p>
          
          <p style="font-weight: 700;">9.- ¿Todos los datos y documentos son obligatorios para generar mi solicitud?</p>
          <p>
              <ul>Sí, todos los documentos y datos que se solicitan en el sistema son obligatorios.</ul>
          </p>
          
          <p style="font-weight: 700;">10.- ¿Cómo sé que mi solicitud de admisión fue aceptada?</p>
          <p>
              <ul>Cuando esto sucede se te envía un correo con la respuesta sobre tu trámite de admisión al Club, revisa tu correo constantemente.</ul>
          </p>
          
          <p style="font-weight: 700;">11.- ¿Cuánto tiempo tardan en darme una respuesta sobre mi solicitud de admisión?</p>
          <p>
              <ul>Dependerá del tipo de trámite así como de las correcciones que se deban realizar sobre la Solicitud, por lo que es necesario que revise bien sus datos y documentos antes de enviarlos.</ul>
          </p>
          
          <p style="font-weight: 700;">12.- ¿Puedo llevar mis documentos a Atención a socios para que el proceso de admisión sea más rápido?</p>
          <p>
              <ul>No, no es posible. Los trámites de admisión al Club se realizan completamente mediante el Sistema de Solicitudes de Admisión</ul>
          </p>
          
          <p style="font-weight: 700;">13.- ¿Puedo realizar el pago por mi trámite de admisión en caja del Club de Golf Tres Marías?</p>
          <p>
              <ul>No, no es posible. Es necesario que completes todos los pasos desde el Sistema de Solicitudes de Admisión.</ul>
          </p>
          
          <p style="font-weight: 700;">14.-  No deseo continuar con el trámite pero ya he realizado el pago, ¿Puedo solicitar un reembolso?</p>
          <p>
              <ul>No, no es posible realizar un reembolso. Antes de realizar el pago se hace mención de que una vez que lo realices no es posible reembolsar. Si no estás seguro de continuar con el trámite evita realizar el pago.</ul>
          </p>
          
          
          
      
      </div>
         
      </mdb-container>
      
    </div>
    <Footer />
  </div>

</template>


<script>
import { mdbContainer, mdbRow, mdbCol } from "mdbvue";
import Footer from "../core/Footer"

export default {
    name:"frequentQuestions",
    components: {
        mdbContainer,
        mdbRow,
        mdbCol,
        Footer
    }

}
</script>

<style>

</style>